import { HttpStatusCode } from './httpStatusCode'
import { toasts } from './toasts'
import { _ } from '@repo/i18n'
import { $t } from '@repo/i18n'
import type { ErrorsV1Error, ErrorsV1ErrorResponse, HttpResponse } from '@sdk/Api'
import { get } from 'svelte/store'

export enum ToastType {
	info,
	success,
	warning,
	error,
}

export type CustomError = {
	code: string
	message: string
	title: string
}

export const generalError = {
	title: $t('error.title'),
	text: $t('error.general'),
	type: ToastType.error,
}

export function handleApiErrors(
	response: HttpResponse<any, ErrorsV1ErrorResponse>,
	customErrors: CustomError[] = null,
) {
	if (customErrors && response.error?.errors) {
		for (const error of response.error.errors) {
			const customError = customErrors.find((e) => e.code === error.code)
			if (customError) {
				toasts.add({
					title: customError.title,
					text: customError.message,
					type: ToastType.error,
				})
				return
			}
		}
	}

	if (response.status === HttpStatusCode.INTERNAL_SERVER_ERROR) {
		handleCommonErrors(response)
	} else if (response.status === HttpStatusCode.NOT_FOUND) {
		toasts.add({
			title: $t('error.NOT_FOUND.title'),
			text: $t('error.NOT_FOUND.text'),
			type: ToastType.error,
		})
	} else if (response.status === HttpStatusCode.CONFLICT) {
		toasts.add({
			title: $t('error.CONFLICT.title'),
			text: $t('error.CONFLICT.text'),
			type: ToastType.error,
		})
	} else {
		// TODO: log error
		console.error(response.error)
		response.error.errors.forEach((error: ErrorsV1Error) => {
			toasts.add({
				title: error.message,
				text: error.message,
				type: ToastType.error,
			})
		})
	}
}

function isTranslationExist(key: string) {
	return get(_)(key) !== key
}

export function handleCommonErrors(response: unknown, message?: string) {
	// TODO: log error
	console.error(response)

	const errorCode = (response as HttpResponse<any, ErrorsV1ErrorResponse>).error?.errors[0]?.code
	const translationKey = `error.${errorCode}`

	toasts.add({
		title: $t('error.title'),
		text: message
			? message
			: errorCode && isTranslationExist(translationKey)
				? $t(translationKey)
				: $t('error.general'),
		type: ToastType.error,
	})
}

export function handleErrors(error: any) {
	if (error?.error) {
		handleApiErrors(error)
	} else {
		handleCommonErrors(error)
	}
}
